import { render, staticRenderFns } from "./CapitalShiftToAffirm.vue?vue&type=template&id=a087c834&scoped=true&"
import script from "./CapitalShiftToAffirm.vue?vue&type=script&lang=ts&"
export * from "./CapitalShiftToAffirm.vue?vue&type=script&lang=ts&"
import style0 from "./CapitalShiftToAffirm.vue?vue&type=style&index=0&id=a087c834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a087c834",
  null
  
)

export default component.exports